import React, { useState } from 'react';
import { defineMessages, useIntl } from 'react-intl';

import IconButton from '@atlaskit/button/icon/button';
import ShowMoreHorizontalIcon from '@atlaskit/icon/core/show-more-horizontal';
import DropdownMenu from '@atlaskit/dropdown-menu/dropdown-menu';
import DropdownItem from '@atlaskit/dropdown-menu/dropdown-menu-item';
import DropdownItemGroup from '@atlaskit/dropdown-menu/dropdown-menu-item-group';

const i18n = defineMessages({
	moreOptions: {
		id: 'space-curation.close-menu.more-options',
		defaultMessage: 'More options',
		description: 'Accessible label for the button to open the close menu',
	},
	remindTomorrow: {
		id: 'space-curation.close-menu.remind-tomorrow',
		defaultMessage: 'Remind me tomorrow',
		description:
			'The text is shown as a dropdown menu item in the space curation card close menu. When the user clicks this item, the card is temporarily hidden and reappears the next day.',
	},
	neverShowAgain: {
		id: 'space-curation.close-menu.never-show-again',
		defaultMessage: 'Never show again',
		description:
			'The text is shown as a dropdown menu item in the space curation card close menu. When the user clicks this item, the card is permanently hidden and will not appear again.',
	},
});

type CloseMenuProps = {
	onDismiss: () => void;
	onNeverShowAgain: () => void;
};

export const CloseMenu = ({ onDismiss, onNeverShowAgain }: CloseMenuProps): React.JSX.Element => {
	const intl = useIntl();
	const [isOpen, setIsOpen] = useState(false);

	return (
		<DropdownMenu
			isOpen={isOpen}
			onOpenChange={({ isOpen: nextIsOpen }) => setIsOpen(nextIsOpen)}
			trigger={({ triggerRef, ...triggerProps }) => (
				<IconButton
					{...triggerProps}
					ref={triggerRef}
					icon={(iconProps) => <ShowMoreHorizontalIcon {...iconProps} size="small" />}
					appearance="subtle"
					spacing="compact"
					label={intl.formatMessage(i18n.moreOptions)}
					isTooltipDisabled={false}
				/>
			)}
		>
			<DropdownItemGroup>
				<DropdownItem
					onClick={() => {
						setIsOpen(false);
						onDismiss();
					}}
				>
					{intl.formatMessage(i18n.remindTomorrow)}
				</DropdownItem>
				<DropdownItem
					onClick={() => {
						setIsOpen(false);
						onNeverShowAgain();
					}}
				>
					{intl.formatMessage(i18n.neverShowAgain)}
				</DropdownItem>
			</DropdownItemGroup>
		</DropdownMenu>
	);
};
